"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("../../../../../core/button"));
var _pdfButton = _interopRequireDefault(require("../../../../../core/pdf-button"));
var _modal = _interopRequireDefault(require("../../../../../core/modal"));
var _table = _interopRequireDefault(require("../../../../../core/table"));
var _chooseEntries = _interopRequireDefault(require("./choose-entries"));
var _chooseColourType = _interopRequireDefault(require("./choose-colour-type"));
var _chooseCardType = _interopRequireDefault(require("./choose-card-type"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function getInitialState(competitionDivisions) {
  return {
    selectingPDFOptions: false,
    choosingCardType: false,
    choosingColourType: false,
    generatingPDF: false,
    cardType: null,
    colourType: null,
    includePostal: true,
    dateRestriction: null,
    selectedDivisions: competitionDivisions.map(d => d.id)
  };
}
class CreateEntryCards extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", getInitialState(this.props.competitionDay.competitionDivisions));
    _defineProperty(this, "_isSelected", id => {
      return this.state.selectedColumns.indexOf(id) !== -1;
    });
    _defineProperty(this, "_onCloseCancel", () => {
      this.setState(getInitialState(this.props.competitionDay.competitionDivisions));
    });
    _defineProperty(this, "_onBegin", () => {
      this.setState({
        selectingPDFOptions: true
      });
    });
    _defineProperty(this, "_onChooseCardType", () => {
      this.setState({
        choosingCardType: true
      });
    });
    _defineProperty(this, "_onChooseColourType", () => {
      this.setState({
        choosingColourType: true
      });
    });
    _defineProperty(this, "_onChangeCardType", cardType => {
      this.setState({
        cardType
      });
    });
    _defineProperty(this, "_onChangeColourType", colourType => {
      this.setState({
        colourType
      });
    });
    _defineProperty(this, "_setDateRestriction", dateRestriction => {
      this.setState({
        dateRestriction
      });
    });
    // If the bib colour gets set then default text to black (or white if black bib)
    // Vice-versa when setting text
    // If the bib colour (text or bib gets cleared then remove).
    _defineProperty(this, "_setNonRankedBibColour", (classDivisionID, field, value) => {
      const existingColours = this._getNonRankedBibColours(classDivisionID);
      if (!value) {
        return this.props.onUpsertCompetitionBib(this.props.competition.id, classDivisionID, null, null);
      }
      return this.props.onUpsertCompetitionBib(this.props.competition.id, classDivisionID, field === 'bibMain' ? value : !existingColours.bibMain ? value === 'white' ? 'black' : 'white' : existingColours.bibMain === value ? value === 'white' ? 'black' : 'white' : existingColours.bibMain, field === 'bibText' ? value : !existingColours.bibText ? value === 'black' ? 'white' : 'black' : existingColours.bibText === value ? value === 'black' ? 'white' : 'black' : existingColours.bibText);
    });
    _defineProperty(this, "_setRaceBibColour", (id, field, value) => {
      this.props.onUpdateRaceBib(id, field, value);
    });
    _defineProperty(this, "_onToggleDivision", (id, isSelected) => {
      this.setState({
        selectedDivisions: isSelected ? this.state.selectedDivisions.concat([id]) : this.state.selectedDivisions.filter(i => i !== id)
      });
    });
    _defineProperty(this, "_onTogglePostal", () => {
      this.setState({
        includePostal: !this.state.includePostal
      });
    });
    // this automatically closes the modal, but delays to allow some time for downloading
    // ideally want to know when generating is finished, but this is a compromise.
    _defineProperty(this, "_onGeneratingPDF", () => {
      this.setState({
        generatingPDF: true
      });
      setTimeout(() => {
        this._onCloseCancel();
      }, 2500);
    });
    _defineProperty(this, "_getNonRankingRaces", () => {
      return this.props.competitionDay.competitionDivisions
      //  only consider select divisions that are none ranking
      .filter(cd => this.state.selectedDivisions.indexOf(cd.id) !== -1 && !cd.isRanking)
      // extract the races and only use those that are onthis day and have some entries
      .reduce((accumulator, cd) => [...accumulator, ...cd.races], []).filter(r => r.competitionDayID === this.props.competitionDay.id && this.props.competitionDay.entries.some(e => e.raceID === r.id && e.entryStatusRef === 'COMP'));
    });
    _defineProperty(this, "_getNonRankedBibColours", classDivisionID => {
      const colours = this.props.competition.competitionBibs.filter(cb => cb.classDivisionID === classDivisionID);
      if (colours && colours.length) {
        return {
          bibMain: colours[0].bibMain,
          bibText: colours[0].bibText
        };
      }
      return {
        bibMain: null,
        bibText: null
      };
    });
    // get nonranked classDivisions which have some entries
    // that are not in a nonranking race that has colours defined
    // and add in any colours previously defined
    //  - eg guests/div 4s
    _defineProperty(this, "_getNonRankedClassDivisions", () => {
      const nonRankedDivs = this.props.classDivisions.filter(cd => !cd.isRanking && this.props.competitionDay.entries.some(e => {
        return e.entryStatusRef === 'COMP' && e.classDivisionID === cd.id && (!this.state.raceColours || !this.state.raceColours[e.raceID]);
      }));
      // add in the current colours for this competition
      return nonRankedDivs.map(div => {
        return {
          ...div,
          raceName: div.rankingDivisionDescription + ' ' + div.classDescription,
          ...this._getNonRankedBibColours(div.id)
        };
      });
    });
  }
  render() {
    const modalButtons = /*#__PURE__*/_react.default.createElement("div", null, this.state.choosingCardType ? /*#__PURE__*/_react.default.createElement(_pdfButton.default, {
      name: "entry-cards",
      args: {
        competitionDayID: this.props.competitionDay.id,
        includePostal: this.state.includePostal,
        selectedDivisions: this.state.selectedDivisions,
        usePreprintedCards: this.state.cardType === 'PRE-PRINTED',
        useColour: this.state.colourType === 'COLOUR',
        dateRestriction: this.state.dateRestriction
      },
      type: "primary",
      disabled: !this.state.cardType || this.state.generatingPDF,
      onClick: this._onGeneratingPDF
    }, "Create PDF of Entry Cards") : this.state.choosingColourType ? /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "primary",
      onClick: this._onChooseCardType,
      disabled: !this.state.colourType
    }, "Next") : /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "primary",
      onClick: this._onChooseColourType
    }, "Next"), ' ', /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onCloseCancel
    }, "Cancel"));
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      style: {
        marginTop: 8
      },
      onClick: this._onBegin,
      type: "primary",
      block: true
    }, "Create Entry Cards"), !this.state.selectingPDFOptions ? null : /*#__PURE__*/_react.default.createElement(_modal.default, {
      title: "Create PDF of Entry Cards",
      buttons: modalButtons,
      onClose: this._onCloseCancel
    }, this.state.choosingCardType ? /*#__PURE__*/_react.default.createElement(_chooseCardType.default, {
      cardType: this.state.cardType,
      onChangeCardType: this._onChangeCardType
    }) : this.state.choosingColourType ? /*#__PURE__*/_react.default.createElement(_chooseColourType.default, {
      colourType: this.state.colourType,
      onChangeColourType: this._onChangeColourType,
      nonRankingRaces: this._getNonRankingRaces(),
      setRaceBibColour: this._setRaceBibColour,
      nonRankedClassDivisions: this._getNonRankedClassDivisions(),
      setNonRankedBibColour: this._setNonRankedBibColour
    }) : /*#__PURE__*/_react.default.createElement(_chooseEntries.default, {
      includePostal: this.state.includePostal,
      onTogglePostal: this._onTogglePostal,
      competitionDivisions: this.props.competitionDay.competitionDivisions,
      selectedDivisions: this.state.selectedDivisions,
      onToggleDivision: this._onToggleDivision,
      dateRestriction: this.state.dateRestriction,
      setDateRestriction: this._setDateRestriction
    })));
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(CreateEntryCards, "partialQueries", {
  CompetitionDay: {
    id: true,
    competitionDivisions: _mergeBqlQueries({
      id: true,
      isRanking: true,
      races: {
        id: true,
        competitionDayID: true,
        raceName: true,
        bibMain: true,
        bibText: true
      }
    }, _chooseEntries.default.partialQueries.CompetitionDivisions),
    entries: {
      raceID: true,
      entryStatusRef: true,
      classDivisionID: true
    }
  }
});
var _ref = {
  id: true,
  competitionBibs: {
    competitionID: true,
    classDivisionID: true,
    bibMain: true,
    bibText: true
  }
};
var _ref2 = {
  id: true,
  isRanking: true,
  rankingDivisionDescription: true,
  classDescription: true
};
var _default = exports.default = (0, _reactBicycle.connect)(CreateEntryCards, props => ({
  ["competition(competitionSlug:" + JSON.stringify(props.competitionSlug) + ",yearID:" + JSON.stringify(+props.yearID) + ")"]: _ref,
  classDivisions: _ref2
}), (client, props) => ({
  onUpdateRaceBib(id, field, value) {
    return client.update('Race.set', {
      id,
      field,
      value
    });
  },
  onUpsertCompetitionBib(competitionID, classDivisionID, bibMain, bibText) {
    return client.update('CompetitionBibs.upsert', {
      competitionID,
      classDivisionID,
      bibMain,
      bibText
    });
  }
}));